import { React, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import PointDropdown from "../../PointDropdown/PointDropdown";
import NotificationDropdown from "../../NotificationDropdown/NotificationDropdown";
import UserDropdown from "../../HeaderDropdowns/UserDropdown";
import { Button } from "../../../Buttons";

import { LeaderBoardModal } from "../../../../modals";

import { CoinIcon } from "../../../../../assets";

import usersService from "../../../../../services/userService";

function StudentHeaderNavDesktop({ userInfo, point_earned }) {
  const { t } = useTranslation();
  const [pointDropdown, setPointDropdown] = useState(false);
  const [notificationDropdown, setNotificationDropdown] = useState(false);
  const [userDropdown, setUserDropdown] = useState(false);
  const [visibleLeaderboardModal, setVisibleLeaderboardModal] = useState(false);

  const notificationClasses = classNames(
    "navButton navButtonDrop hasIcon--mail withoutText",
    {
      active: notificationDropdown,
    }
  );

  return (
    <nav>
      <OutsideClickHandler onOutsideClick={() => setPointDropdown(false)}>
        <section
          onClick={() => setPointDropdown(!pointDropdown)}
          className="coinButton"
          title={userInfo?.name}
        >
          <img
            src={CoinIcon}
            className={`coin-icon ${
              point_earned && point_earned !== "false" && "coin-animation-play"
            }`}
            alt="Coin"
          />
          <span>{userInfo?.points}</span>
          {pointDropdown && (
            <PointDropdown
              setVisibleLeaderboardModal={setVisibleLeaderboardModal}
            />
          )}
        </section>
      </OutsideClickHandler>

      <Button
        customClassName="navButton withoutText"
        iconClassName="hasIcon--grid"
        onClick={() => usersService.goToMonolith("dashboard/")}
      />

      <OutsideClickHandler
        onOutsideClick={() => setNotificationDropdown(false)}
      >
        <section
          onClick={() => usersService.goToMonolith("mail/students_emails/")}
          className={notificationClasses}
          title={t("notifications")}
        >
          {userInfo?.new_emails_and_notifications_count > 0 && (
            <div className="menu-counter">{userInfo?.new_emails_and_notifications_count}</div>
          )}
          {notificationDropdown && (
            <NotificationDropdown
              notifications={userInfo?.notifications?.notifications}
            />
          )}
        </section>
      </OutsideClickHandler>

      <OutsideClickHandler onOutsideClick={() => setUserDropdown(false)}>
        <section
          onClick={() => setUserDropdown(!userDropdown)}
          className={`navButton navButtonDrop withoutText userAvatar ${
            !userInfo?.avatar_url && "hasIcon--user"
          }`}
          title={userInfo?.name}
        >
          {userInfo?.avatar_url && (
            <img src={userInfo?.avatar_url} alt={userInfo?.name} />
          )}
          {userDropdown && <UserDropdown userInfo={userInfo} />}
        </section>
      </OutsideClickHandler>

      {visibleLeaderboardModal && (
        <LeaderBoardModal
          setVisibleLeaderboardModal={setVisibleLeaderboardModal}
        />
      )}
    </nav>
  );
}

export default StudentHeaderNavDesktop;
